// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productMiniCardStyles } from "@sc/App/Components/Product/ProductMiniCard";
import { ellipsis, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

productMiniCardStyles.productGridContainerStyles = {
    info: {
        css: css`
            flex-basis: 100%;
        `,
    },
    priceAndActions: {
        css: css`
            height: auto;
        `,
    },
};
productMiniCardStyles.imageAndDescriptionSection = {
    css: css`
        display: flex;
        gap: 12px;
        height: 100%;
    `,
};
productMiniCardStyles.descritopnContainerStyles = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
productMiniCardStyles.productImage = {
    linkWrappingImage: {
        css: css`
            width: 91px;
            height: 91px;
            align-items: flex-start;
        `,
    },
};
productMiniCardStyles.productDescription = {
    productDetailDescription: {
        css: css`
            min-height: 42px;
            ${xScreen("lte", 767)} {
                min-height: auto;
            }
        `,
    },
    productDetailLink: {
        css: css`
            min-height: 42px;
            ${xScreen("lte", 767)} {
                min-height: auto;
            }
        `,
    },
};

productMiniCardStyles.productPriceAndActionsTopSectionStyles = {
    productGridContainer: {
        container: {
            css: css`
                max-width: initial;
                height: auto;
            `,
        },
    },
    productAvailabilityStyles: {
        container: {
            css: css`
                .inventory-out-of-stock-pickup {
                    ${ellipsis(1)}
                }
            `,
        },
        messageText: {
            css: css`
                ${ellipsis(1)}
            `,
        },
    },
};

productMiniCardStyles.productPriceAndActionsStyles = {
    productGridContainer: {
        container: {
            css: css`
                height: auto;
                max-width: initial;
            `,
        },
    },
    bottomSectionContainer: {
        css: css`
            margin-top: 0;
        `,
    },
    productActionsStyles: {
        addToCartButtonWrapper: {
            css: css`
                width: 100%;
            `,
        },
    },
};
productMiniCardStyles.productPartNumbersStyles = {
    container: {
        css: css`
            ${xScreen("lte", 767)} {
                margin-bottom: 22px;
            }
        `,
    },
};
productMiniCardStyles.brandWrapper = {
    css: css`
        min-height: 13px;
    `,
};
